import { render, staticRenderFns } from "./LaguageSwitcher.vue?vue&type=template&id=c912b0c6&scoped=true&"
import script from "./LaguageSwitcher.vue?vue&type=script&lang=js&"
export * from "./LaguageSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./LaguageSwitcher.vue?vue&type=style&index=0&id=c912b0c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c912b0c6",
  null
  
)

export default component.exports